import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { ButtonModule, PreloaderModule, SmartbarModule, SvgIconModule, TabModule } from '@hdms/shared/ui-core';

import { ContactFooterComponent } from './contact-footer.component';
import { ContactFooterContentComponent } from './content/contact-footer-content.component';

@NgModule({
  declarations: [ContactFooterComponent, ContactFooterContentComponent],
  imports: [CommonModule, ButtonModule, TabModule, SmartbarModule, SvgIconModule, TranslationModule, PreloaderModule],
  exports: [ContactFooterComponent]
})
export class ContactFooterModule {}
